<template>
  <div class="rule-add">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="130px">
      <el-form-item label="范围类型" prop="useRange">
        <el-select @change="changeUseRange" v-model="form.useRange" placeholder="请选择范围类型">
          <el-option v-for="(item, index) in useRangeOption" :label="item.label" :value="item.value"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="适用范围" prop="mallId" v-if="form.useRange == 'Mall'">
        <el-select v-model="form.mallId" placeholder="请选择适用范围" multiple>
          <el-option v-for="(item, index) in mallList" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="适用范围" prop="storeId" v-if="form.useRange == 'Store'">
        <el-cascader v-model="form.storeId" placeholder="请选择适用范围" :options="storeList" filterable
          :props="shopCascaderProps" clearable :show-all-levels="false">
        </el-cascader>
      </el-form-item>
      <el-form-item label="适用范围" prop="category" v-if="form.useRange == 'Category'">
        <el-select v-model="form.category" placeholder="请选择适用范围" multiple>
          <el-option v-for="(item, index) in categoryList" :key="index" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="积分获取规则" prop="consumeAmount" class="disLB">
        <el-input oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" v-model="form.consumeAmount" class="input">
          <template slot="prepend">每消费</template>
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label-width="48px" label="获得" prop="gainPoint" class="disLB">
        <el-input oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" v-model="form.gainPoint" class="input W200">
          <template slot="append">积分</template>
        </el-input>
      </el-form-item>
      <el-form-item label="积分有效期" prop="days">
        <el-input oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" v-model="form.days" class="input">
          <template slot="append">天</template>
        </el-input>
        <!-- <span class="input-remark">（积分发放后生效，填写"0"代表永久有效）</span> -->
      </el-form-item>
      <el-form-item label="积分抵扣规则" prop="deduction" class="disLB">
        <el-input oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" v-model="form.deduction" class="input">
          <template slot="prepend">每使用</template>
          <template slot="append">积分</template>
        </el-input>
      </el-form-item>
      <el-form-item label="抵扣" label-width="48px" prop="deductionAmount" class="disLB">
        <el-input oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" v-model="form.deductionAmount" class="input W200">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="积分抵扣比例" prop="deductionRatio">
        <el-input oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" v-model="form.deductionRatio" class="input">
          <template slot="append">%</template>
        </el-input>
        <span class="input-remark">（订单金额 x 抵扣比例 = 优惠金额；积分按照上述抵扣规则换算）</span>
      </el-form-item>
      <el-form-item label="单笔积分抵扣上限" prop="deductionLimit">
        <el-input oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" v-model="form.deductionLimit" placeholder="请输入单笔积分抵扣上限" />
      </el-form-item>
      <el-form-item label="用户日抵扣上限" prop="dayDeductionLimit">
        <el-input oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" v-model="form.dayDeductionLimit" placeholder="请输入用户日抵扣积分上限" />
      </el-form-item>
      <el-form-item label="用户月抵扣上限" prop="monthDeductionLimit">
        <el-input oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" v-model="form.monthDeductionLimit" placeholder="请输入用户月抵扣积分上限" />
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="onBack" class="fun-btn mr20">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="onSubmit" class="fun-btn">确定</el-button>
    </div>
  </div>
</template>

<script>
import { api_getPointRule, api_postPointRule, api_putPointRule } from '@/api/accumulationScore'
import { api_getConfig } from "@/api/common";
export default {
  name: "memberGradeAdd",
  components: {
  },
  data() {
    return {
      form: {
        useRange: '',
        mallId: [],
        storeId: [],
        category: [],
        consumeAmount: '',
        gainPoint: '',
        days: '',
        deduction: '',
        deductionAmount: '',
        deductionRatio: '',
        dayDeductionLimit: '',
        deductionLimit: '',
        monthDeductionLimit: '',
        disable: true,
      },
      rules: {
        useRange: [{ required: true, message: '请选择范围类型' }],
        mallId: [{ required: true, message: '请选择适用范围' }],
        storeId: [{ required: true, message: '请选择适用范围' }],
        category: [{ required: true, message: '请选择适用范围' }],
        consumeAmount: [{ required: true, message: '请填写积分获取规则' }],
        gainPoint: [{ required: true, message: '请填写积分获取规则' }],
        days: [{ required: true, message: '请填写积分有效期' }],
        // deduction: [{ required: true, message: '请填写积分抵扣规则' }],
        // deductionAmount: [{ required: true, message: '请填写积分抵扣规则' }],
        // deductionRatio: [{ required: true, message: '请填写积分抵扣比例' }],
      },
      mallList: [],
      storeList: [],
      categoryList: [],
      useRangeOption: [{
        label: '商城',
        value: 'Mall'
      }, {
        label: '业态',
        value: 'Category'
      }, {
        label: '店铺',
        value: 'Store'
      }],
      shopCascaderProps: {
        multiple: true,
        value: "id",
        label: "name",
        emitPath: false,
      },
      submitLoading: false
    };
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.getDetailDate() // 获取详情数据
    } else {
    }
    this.getConfigData()
  },
  methods: {
    changeUseRange () {
      setTimeout(()=> {
        this.$refs['form'].clearValidate(['mallId', 'storeId', 'category']);
        this.form.mallId = this.form.storeId = this.form.category = []
      }, 0)
    },
    // 获取所属业态数据
    async getConfigData() {
      let { category = [], storeThreeLevel = [], mall = []} = await api_getConfig(['category', 'mall', 'storeThreeLevel'])
      this.mallList = mall.map(item => {
        return {
          label: item.name,
          value: item.id + ''
        }
      })
      this.storeList = storeThreeLevel
      this.categoryList = category.map(item => {
        return {
          label: item.name,
          value: item.id + ''
        }
      })
    },
    // 获取详情数据
    async getDetailDate() {
      const data = await api_getPointRule({ id: this.$route.query.id })
      let { range, storeIds=[], useRange, mallId='', category='', consumeAmount, gainPoint, days, disable, deductionRatio, deduction, deductionAmount, dayDeductionLimit, monthDeductionLimit, deductionLimit } = data
      mallId = mallId.split(',')
      category = category.split(',')
      this.form = { range, useRange, mallId, category, consumeAmount, gainPoint, days, disable, deductionRatio, deduction, deductionAmount, dayDeductionLimit, monthDeductionLimit, deductionLimit }
      this.form.storeId = storeIds
      console.log(this.form)
      setTimeout(()=> {
        this.$refs['form'].clearValidate()
      }, 0)
    },

    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let params = {
            ...this.form,
          }
          try {
            this.$route.query.id ? await api_putPointRule({ ...params, id: this.$route.query.id }) : await api_postPointRule(params)
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },
    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
};
</script>

<style lang="scss" scoped>
.rule-add {
  width: 100%;
  padding: 35px 20px;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 100px;

  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader {
    width: 350px;
  }

  .W200 {
    width: 200px;
  }

  .disLB {
    display: inline-block;
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .optional {
    height: 17px;
    line-height: 17px;
    margin-top: 5px;
    font-size: 12px;
    color: #666666;
  }

  .footer {
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
